import { actionTypes } from "..";
import { makeAllObjToArr } from "../../helpers";

const initialState = {
  // customers
  customersData: null,
  downloadUrl: null,
  customerFormOptions: null,
  customerEditData: null,

  // payees
  payeeList: null,
  addEditPayeeData: null,
  recurringPaymentsModal: false,
  payeeDocumentModal: false,
  payeeBankingInfoModal: false,

  addPayeePendingApprovalData: null,

  // ar invoices
  newArInvoicesOptions: null,
  editArInvoiceData: null,

  arInvoicesData: null,
  outstandingArInvoicesData: null,
  cancelledArInvoicesData: null,
  paidArInvoicesData: null,

  // finance receivables
  receivablesList: null,
  receivableDetails: null,

  creditNoteList: null,
};

const orderInvoicesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.SAVE_ORDER_INVOICES_VALUE: {
      return { ...state, ...payload };
    }

    case actionTypes.SET_MODAL_STATE: {
      return { ...state, [payload.modalName]: payload.modalState };
    }

    case actionTypes.SET_FORM_STATE: {
      return { ...state, [payload.formName]: payload.formState };
    }

    default:
      return state;
  }
};
export default orderInvoicesReducer;
